/**
 * Field ids for study configuration (post-create / configuration UI).
 * Align with product matrix (e.g. GOLD-11611 "Editable" column) — extend as more rows get inline edit.
 */
export const STUDY_CONFIGURATION_EDITABLE_FIELD_IDS = {
  participantSessionTimeout: 'participant_session_timeout',
  visitSupportEnableVisitTime: 'visit_support_enable_visit_time',
}

const EDITABLE_SET = new Set(Object.values(STUDY_CONFIGURATION_EDITABLE_FIELD_IDS))

export const isStudyConfigurationFieldEditable = fieldId =>
  fieldId != null && EDITABLE_SET.has(fieldId)
